<script setup>
import { computed, toRef, onMounted, onUnmounted } from 'vue'
import { MapSource, MapLayer } from '@/components/map'
import { useLayerManager } from '@/composables/useLayerManager'
import { createLayerId, createSourceId } from '@/components/layers/types'
import { buildBasemapTileUrl } from '@/lib/tileUrl'

const props = defineProps({
  map: { type: Object, required: true },
  beforeId: { type: String, required: true },
  groupId: { type: String, required: true },
  layerId: { type: String, required: true },
  layer: { type: Object, default: null },
  isVisible: { type: Boolean, default: true },
  options: { type: Object, default: () => ({}) }
})

const layerManager = useLayerManager(toRef(props, 'map'))

const emit = defineEmits(['isLoaded'])

const tileUrl = computed(() => buildBasemapTileUrl(props.layer))

const sourceId = computed(() => createSourceId(props.groupId, 'basemap-source'))
const rasterLayerId = computed(() => createLayerId(props.groupId, 'basemap-raster'))

onMounted(() => {
  layerManager.registerLayer(props.groupId, rasterLayerId.value)
  emit('isLoaded', true)
})

onUnmounted(() => {
  layerManager.unregisterLayer(props.groupId, rasterLayerId.value)
})
</script>

<template>
  <div v-if="map && tileUrl">
    <MapSource
      :map="map"
      type="raster"
      :id="sourceId"
      :options="{ tiles: [tileUrl], tileSize: 256 }"
    >
      <MapLayer
        :map="map"
        :id="rasterLayerId"
        type="raster"
        :source="sourceId"
        :before-id="beforeId"
        :group-id="groupId"
        :options="{
          ...options,
          layout: { visibility: isVisible ? 'visible' : 'none' },
          paint: { 'raster-opacity': 1.0 }
        }"
      />
    </MapSource>
  </div>
</template>
